export default __webpack_public_path__ + "static/section4Img-b38d5f8fe47e95e289598c8df4fefd61.png";